import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamily = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.5 8.25C21.1569 8.25 22.5 6.90685 22.5 5.25C22.5 3.59315 21.1569 2.25 19.5 2.25C17.8431 2.25 16.5 3.59315 16.5 5.25C16.5 6.90685 17.8431 8.25 19.5 8.25Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.812 20.25L18 21.75H21L21.75 15.75H23.25V13.5C23.25 12.8036 23.0561 12.1209 22.6899 11.5285C22.3238 10.9361 21.7999 10.4573 21.1771 10.1459C20.5542 9.83445 19.8568 9.70261 19.1632 9.76515C18.4696 9.8277 17.8071 10.0821 17.25 10.5",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.5 8.25C6.15685 8.25 7.5 6.90685 7.5 5.25C7.5 3.59315 6.15685 2.25 4.5 2.25C2.84315 2.25 1.5 3.59315 1.5 5.25C1.5 6.90685 2.84315 8.25 4.5 8.25Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.188 20.25L6 21.75H3L2.25 15.75H0.75V13.5C0.75 12.8036 0.94393 12.1209 1.31006 11.5285C1.67619 10.9361 2.20005 10.4573 2.82295 10.1459C3.44585 9.83445 4.14317 9.70261 4.83677 9.76515C5.53038 9.8277 6.19286 10.0821 6.75 10.5",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 11.25C13.2426 11.25 14.25 10.2426 14.25 9C14.25 7.75736 13.2426 6.75 12 6.75C10.7574 6.75 9.75 7.75736 9.75 9C9.75 10.2426 10.7574 11.25 12 11.25Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12.75C11.0054 12.75 10.0516 13.1451 9.34835 13.8483C8.64509 14.5516 8.25 15.5054 8.25 16.5V17.25H9.75L10.5 21.75H12",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12.75C12.9946 12.75 13.9484 13.1451 14.6517 13.8483C15.3549 14.5516 15.75 15.5054 15.75 16.5V17.25H14.25L13.5 21.75H12",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	});
};
export default SvgFamily;
